@if (isReady) {
  <idp-flyout-search
    (searchValue)="onSearchValueChange($event)"
    [displayFlyout]="displayFlyout"
    [content]="(flyoutContent$ | ngrxPush) || emptyFlyoutContent"
    [autocompleteSuggestions]="filteredSuggestions"
    (submitTerm)="submitSearch($event)"
    (suggestionSelected)="submitSearch($event)"
    (closeFlyoutSearch)="closeFlyout()"
    (selectValue)="updateAnalytics($event)"
    [footerFlyoutSearch]="displayFooterSearch"
  ></idp-flyout-search>
} @else {
  <div class="flex justify-center items-center">
    <span class="component-loader"></span>
  </div>
}
